import { width } from './general';

export default <const>{
  container: {
    zIndex: 999,
    width,
    height: 130,
    visible: false,
    opacity: 0,
    infinite: true,
    canHandleEvents: false,
    flex: {
      alignItems: 'flex-end',
      justifyContent: 'center',
    },
  },

  button: {
    image: 'assets/ui/shared/lossless/btn_footer.png',
    width: 139,
    height: 130,
    scaleMethod: '9slice',
    sourceSlices: {
      horizontal: { left: 13, right: 13 },
      vertical: { top: 13, bottom: 26 },
    },
    font: 'Body',
    align: 'center',
    fontSize: 22,
    textColor: '#C57C58',
    labelHeight: 28,
    labelOffsetY: 82,
  },
  buttonActive: {
    image: 'assets/ui/shared/lossless/btn_footer_active.png',
  },

  actionIcons: {
    menu: {
      image: `assets/ui/shared/icons/footer_menu.png`,
      height: 58,
      width: 90,
      offset: { x: 0, y: -23 },
    },
    menuActive: {
      image: `assets/ui/shared/icons/footer_menu_active.png`,
    },
    visit: {
      image: `assets/ui/shared/icons/footer_visit.png`,
      height: 58,
      width: 90,
      offset: { x: 0, y: -23 },
    },
    visitActive: {
      image: `assets/ui/shared/icons/footer_visit_active.png`,
    },
    friends: {
      image: `assets/ui/friends/friend_menu_icon.png`,
      height: 58,
      width: 90,
      offset: { x: 0, y: -23 },
    },
    friendsActive: {
      image: `assets/ui/friends/friend_menu_icon_active.png`,
    },
    care: {
      image: `assets/ui/shared/icons/footer_care.png`,
      height: 58,
      width: 90,
      offset: { x: 0, y: -23 },
    },
    careActive: {
      image: `assets/ui/shared/icons/footer_care_active.png`,
    },
    game: {
      image: `assets/ui/shared/icons/footer_game.png`,
      height: 58,
      width: 90,
      offset: { x: 0, y: -23 },
    },
    gameActive: {
      image: `assets/ui/shared/icons/footer_game_active.png`,
    },
    shop: {
      image: `assets/ui/shared/icons/footer_shop.png`,
      height: 58,
      width: 90,
      offset: { x: 0, y: -23 },
    },
    shopActive: {
      image: `assets/ui/shared/icons/footer_shop_active.png`,
    },
  },
};
